/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import {
  Table, TableHead, TableBody, TableCell, TableRow, Chip, makeStyles, Tooltip,
  Card,
  CardContent,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { ChatBubble, Flag, ReplayOutlined } from '@material-ui/icons';
import { connect } from 'react-redux';
import { CommonButton, CommonModal } from '../../CommonComponents';
import { showToast } from '../../Utils';
import { updateSiteActionableItemAdmin } from '../../redux/actions/sites';

const useStyles = makeStyles((theme) => ({
  problemWithSite: {
    backgroundColor: theme.palette.warning.main,
  },
  buttonWrapper: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },

  regularRow: {},
}))

const renderType = (type) => {
  switch (type) {
    case 'sd':
      return 'Start Date';
    case 'ed':
      return 'End Date';
    case 'night':
      return 'Night Photo';
    default:
      return 'Default';
  }
};

function CamparisonSubTable({
  open, vendorUser, handleViewDetails, site, setDatePicker,
  updateActionable,
}) {
  const [showModal, setShowModal] = useState(null);
  const [reason, setReason] = useState('');
  const classes = useStyles();
  const siteReports = site.site_reports
  if (siteReports === undefined) { return null }
  const user = JSON.parse(localStorage.getItem('user'))

  const handleReject = () => {
    if (!reason.trim().length) {
      showToast('warn', 'Please provide valid reason for reject.')
      return;
    }
    setReason('');
    const task = { ...showModal };
    if (task.type === 'default') {
      updateActionable(site.id, task.id, true, reason);
    } else {
      const itm = site?.actionabletasks?.length
        ? site.actionabletasks.find((
          (item) => item.siteReportId === task.id)) : undefined;
      if (itm) {
        updateActionable(site.id, itm.id, true, reason);
      }
    }
    showToast('success', 'Review requested successfully!')
    setShowModal(null);
  }
  return (
    <>
      <TableRow style={{ backgroundColor: site.visibleToAuditor ? '#f4e7f6' : 'transparent' }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={16}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {siteReports.length || site?.actionabletasks?.length ? (
              <Box margin={1}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell><b>Report Date</b></TableCell>
                      <TableCell><b>Status</b></TableCell>
                      <TableCell><b>Monitor Comment</b></TableCell>
                      <TableCell><b>Monitor</b></TableCell>
                      <TableCell><b>Details</b></TableCell>
                      <TableCell><b>Type</b></TableCell>
                      <TableCell><b>Auditor Action</b></TableCell>
                      {/* <TableCell><b /></TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {site?.actionabletasks?.filter((item) => item.type === 'default').map((item) => {
                      const isProblem = (parseInt(item?.auditorAction, 10) !== 1 && item?.auditorComments)
                      return (
                        <TableRow
                          key={item}
                          className={classes.regularRow}
                          style={{
                            backgroundColor: isProblem ? '#f6c5d3' : 'transparent',
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {moment(item.createdAt).format('DD MMM YYYY')}
                          </TableCell>
                          <TableCell>
                            Proposed Photo
                          </TableCell>
                          <TableCell>-</TableCell>
                          <TableCell>
                            -
                          </TableCell>
                          <TableCell>
                            <CommonButton
                              onClick={() => handleViewDetails(item, site)}
                              basic="true"
                              color="primary"
                              className="pl-0"
                            >
                              <b>View Details</b>
                            </CommonButton>
                            {' '}
                          </TableCell>
                          <TableCell>{item?.type ? renderType(item.type) : '-'}</TableCell>
                          <TableCell>
                            <div className="flex flex-row items-center">
                              <Flag
                                htmlColor={
                                    item?.auditorAction
                                      ? item.auditorAction === '0'
                                        ? '#FF0000'
                                        : '#0DC500'
                                      : '#828282'
                                  }
                              />
                              {isProblem
                                ? (
                                  <>
                                    <Tooltip title={item?.auditorComments} placement="top" arrow>
                                      <div className="ml-2">
                                        <ChatBubble htmlColor="#828282" />
                                      </div>
                                    </Tooltip>
                                    <ReplayOutlined htmlColor="#828282" onClick={() => setShowModal(item)} />
                                  </>
                                ) : null}
                            </div>
                          </TableCell>
                          {/* <TableCell>
                            -
                          </TableCell> */}
                        </TableRow>
                      )
                    })}
                    {siteReports.map((row, index) => {
                      if (index === 0) {
                        row.isStartDate = true;
                      }
                      if (index === siteReports.length - 1) {
                        row.isEndDate = true;
                      }
                      const isActionable = site?.actionabletasks?.length
                        ? site.actionabletasks.find((
                          (item) => item.siteReportId === row.id)) : undefined;
                      const isProblem = (parseInt(isActionable?.auditorAction, 10) !== 1
                        && isActionable?.auditorComments)
                      const status = {
                        approved: {
                          color: 'primary',
                        },
                        rejected: {
                          color: 'danger',
                        },
                        expired: {
                          color: 'danger',
                        },
                        pending: {
                          color: 'default',
                        },
                        submitted: {
                          color: 'secondary',
                        },
                      };
                      return (
                        <TableRow
                          key={row.id}
                          className={row.problemWithSite
                            ? classes.problemWithSite : classes.regularRow}
                          style={{
                            backgroundColor: isProblem ? '#f6c5d3' : 'transparent',
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {moment(row.visitDate).format('DD MMM YYYY')}
                            {(user?.userType === 'admin' || user?.userType === 'manager') && row.status === 'pending' && (site.newEndDate ? site.newEndDate : site.endDate) !== row.visitDate
                              ? (
                                <Tooltip title="Click to edit visit date" placement="top" arrow>
                                  <IconButton aria-label="Edit Visit Date">
                                    <EditIcon color="primary" fontSize="small" onClick={() => setDatePicker(row)} />
                                  </IconButton>
                                </Tooltip>
                              )
                              : null}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={row.status}
                              color={status[row.status].color}
                            />
                          </TableCell>
                          <TableCell>{row.vendorRemark}</TableCell>
                          <TableCell>
                            {vendorUser}
                          </TableCell>
                          <TableCell>
                            <CommonButton
                              onClick={() => handleViewDetails(row, site)}
                              basic="true"
                              color="primary"
                              className="pl-0"
                              disabled={row.status !== 'approved' && row.status !== 'rejected' && row.status !== 'submitted'}
                            >
                              <b>View Details</b>
                            </CommonButton>
                            {' '}
                          </TableCell>
                          <TableCell>{isActionable?.type ? renderType(isActionable.type) : '-'}</TableCell>
                          <TableCell>
                            {isActionable
                              ? (
                                <div className="flex flex-row items-center">
                                  <Flag
                                    htmlColor={
                                    isActionable?.auditorAction
                                      ? isActionable.auditorAction === '0'
                                        ? '#FF0000'
                                        : '#0DC500'
                                      : '#828282'
                                  }
                                  />
                                  {isProblem
                                    ? (
                                      <>
                                        <Tooltip title={isActionable?.auditorComments} placement="top" arrow>
                                          <div className="ml-2">
                                            <ChatBubble htmlColor="#828282" />
                                          </div>
                                        </Tooltip>
                                        <ReplayOutlined htmlColor="#828282" onClick={() => setShowModal(row)} />
                                      </>
                                    ) : null}
                                </div>
                              )
                              : null}
                          </TableCell>
                          {/* <TableCell>
                            {[345, 347, 348, 58, 57, 94].includes(user?.id ?? '') && (row.status === 'rejected' || row.status === 'pending' || row.status === 'expired') && moment(row.visitDate).isBefore(moment().startOf('day')) ? (
                              <CommonButton
                                onClick={() => handleWatermark(row, site)}
                                basic="true"
                                color="primary"
                              >
                                <b style={{ fontFamily: 'Noto Sans SemBd' }}>Add a watermark</b>
                              </CommonButton>
                            ) : null}
                          </TableCell> */}
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">No reports available</Typography>
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
      <CommonModal
        open={showModal}
        title="Provide Reason For Review Request Again"
        width="md"
        padded={false}
        onYes={() => {
          handleReject();
        }}
        onClose={() => {
          setReason('');
          setShowModal(null);
        }}
        cancelButtonText="Cancel"
        successButtonText="Request"
      >
        <Card>
          <CardContent>
            <div className="row">
              <div className="col-12">
                <textarea value={reason} className="form-control" rows="3" placeholder="Enter reject reason" style={{ resize: 'none' }} onChange={(e) => setReason(e.target.value)} />
              </div>
            </div>
          </CardContent>
        </Card>
      </CommonModal>
    </>
  );
}

const mapActions = {
  updateActionable: updateSiteActionableItemAdmin,
};

export default connect(null, mapActions)(CamparisonSubTable);
